export type CapitalizeKeys<TObject extends Record<string, unknown>> = Record<
  Capitalize<Extract<keyof TObject, string>>,
  unknown
>;

export const deepPascalCaseToCamelCase = <
  TReturn extends Record<string, unknown>,
  TFrom extends CapitalizeKeys<TReturn>
>(
  entry: TFrom | TFrom[]
): TReturn | TReturn[] | boolean | string | number => {
  if (Array.isArray(entry)) {
    return entry.map((v) => deepPascalCaseToCamelCase(v)) as TReturn[];
  } else if (entry !== null && typeof entry === 'object') {
    return Object.entries(entry).reduce(
      (agg, [key, value]) => ({
        ...agg,
        [`${key[0].toLowerCase()}${key.slice(1)}`]: deepPascalCaseToCamelCase(value as TFrom | TFrom[]),
      }),
      {} as TReturn
    );
  }

  return entry;
};

export const deepPascalCaseToCamelCaseTransformResponseMap = <
  TFrom extends CapitalizeKeys<TTo>,
  TTo extends Record<string, unknown>
>(
  objects: TFrom[]
) => deepPascalCaseToCamelCase(objects) as TTo[];

export const deepPascalCaseToCamelCaseTransformResponse = <
  TFrom extends CapitalizeKeys<TTo>,
  TTo extends Record<string, unknown>
>(
  objects: TFrom[]
) => deepPascalCaseToCamelCase(objects) as TTo;

export type EnvelopeSuccessResponse<TData> = {
  data: TData;
  isFailure: false;
  isSuccess: true;
};

export const envelopeDataTransformResponse = <TFrom extends CapitalizeKeys<EnvelopeSuccessResponse<TTo>>, TTo>(
  envelopeResponse: TFrom
): TTo => {
  return deepPascalCaseToCamelCase(
    envelopeResponse.Data as CapitalizeKeys<Record<string, unknown>> | CapitalizeKeys<Record<string, unknown>>[]
  ) as TTo;
};
